module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-x-fill-422b35cc.svg";